export interface IUnitPermissionUserGroup {
    code: string;
    name: string;
    type: number;
    qrCode: boolean;
    groupCodes: string[];
    groupNames: string[];
}

export class UnitPermissionUserGroup implements IUnitPermissionUserGroup {
    code: string;
    name: string;
    type: number;
    qrCode: boolean;
    groupCodes: string[];
    groupNames: string[];

    constructor();
    constructor(obj: IUnitPermissionUserGroup);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.type = obj && obj.type || 0;
        this.qrCode = obj && obj.qrCode || false;
        this.groupCodes = obj && obj.groupCodes || [];
        this.groupNames = obj && obj.groupNames || [];
    }
}